module.exports = __webpack_public_path__ + "static/img/HU.22b28e4f.png";